import { ReactNode } from "react";
import { Tabs } from "@mantine/core";
import { CustomTable } from "../../../../components/Table/CustomTable";
import { TransactionTypes } from "../../../DataDisplayTable/TransactionTable";
import { RowDataTransaction } from "../../../../components/TransactionPage/types";
import { ThProps } from "../../../../components/TransactionPage/TransactionPage";
import TabI from "../../TabI";
import TransactionTab from "./TransactionTab";

export enum ColumnHeaderToFilterPairAll {
    TRANSACTION_ID = "Transaction ID",
    FULLNAME = "Name",
    TYPE = "Type",
    COINS = "Coins",
    CASH = "Cash",
    CREATED = "Created At",
}

export const colFilterAll = ColumnHeaderToFilterPairAll;
export const colFiltersAll: { [key in ColumnHeaderToFilterPairAll]: string } = {
    [colFilterAll.TRANSACTION_ID]: "transaction_id",
    [colFilterAll.FULLNAME]: "fullname",
    [colFilterAll.TYPE]: "type",
    [colFilterAll.COINS]: "coins",
    [colFilterAll.CASH]: "cash",
    [colFilterAll.CREATED]: "createdAt",
};

class AllTab extends TransactionTab {

    constructor(sortBy: keyof RowDataTransaction | null, setSorting: { (field: keyof RowDataTransaction): void }, Th: { ({ children, sortable, reversed, sorted, onSort }: ThProps): JSX.Element }, rowDataTransaction: RowDataTransaction[] | null) {
        super(sortBy, setSorting, Th, rowDataTransaction)
    }

    create(reverseSortDirection: boolean, classes: { readonly [key: string]: string }, rows: JSX.Element[]): ReactNode {
        return (
            <Tabs.Panel value={TransactionTypes.ALL}>
                <CustomTable
                    colHeaders={Object.values(ColumnHeaderToFilterPairAll)}
                    filters={Object.values(colFiltersAll)}
                    reverseSortDirection={reverseSortDirection}
                    sortBy={this.sortBy}
                    setSorting={this.setSorting}
                    customclasses={classes}
                    Th={this.Th}
                    rowData={this.rowDataTransaction}
                    rows={rows}
                />
            </Tabs.Panel>
        )
    }

}
export default AllTab